module.exports = __webpack_public_path__ + "img/user-13.dd2154d3.jpg";